import React, { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRedirectURL } from '../utils/tokenUtils';

type Props = {
  message?: string;
  children?: JSX.Element;
  hideButton?: boolean;
  style?: React.CSSProperties;
  styleTitle?: React.CSSProperties;
};

const GenericMessagePage: React.FC<Props> = ({ message = "Something went wrong", children, hideButton = false, style, styleTitle }) => {
  const navigate = useNavigate();
  const redirectURL = getRedirectURL();
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleButtonClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (redirectURL) {
      const url = redirectURL.trim();
      window.location.href = url;
    } else {
      navigate('/');
    }
  }, [redirectURL, navigate]);

  return (
    <div className="generic-message-wrapper" style={style}>
      {children && (
        <div className="children-overlay">
          {children}
        </div>
      )}
      <div className="content-container">
        <div className="message-box">
          <h1 style={styleTitle}>{message}</h1>
        </div>
        {(!hideButton && redirectURL) && (
          <div className="button-container">
            <button 
              ref={buttonRef}
              type="button"
              onClick={handleButtonClick}
              className="go-home-button"
            >
              Go Home
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default GenericMessagePage;
